/**
 * FileInputDropdownClose Hook
 *
 * Closes a DaisyUI dropdown when the file upload label is clicked.
 * This ensures the dropdown closes before the file picker dialog opens.
 */
export const FileInputDropdownClose = {
  mounted () {
    const dropdownId = this.el.dataset.dropdownId

    if (!dropdownId) {
      console.warn('FileInputDropdownClose: Missing dropdown ID')
      return
    }

    // Handler to close the dropdown
    const closeDropdown = () => {
      const dropdown = document.getElementById(dropdownId)
      if (dropdown) {
        // Remove focus from all focusable elements in the dropdown
        const focusedElement = dropdown.querySelector(':focus')
        if (focusedElement) {
          focusedElement.blur()
        }

        // Also blur the dropdown's toggle button
        const toggleButton = dropdown.querySelector('button')
        if (toggleButton) {
          toggleButton.blur()
        }

        // Force close by blurring the active element (DaisyUI behavior)
        if (document.activeElement) {
          document.activeElement.blur()
        }
      }
    }

    // Close dropdown immediately when the label is clicked
    this.el.addEventListener('click', closeDropdown)
  }
}
